import { IFaqBase } from '@/models/faqBase.model';
import { FaqFieldsNames, TFaqFormValues } from './types';

export const mapToFormValues = <T extends IFaqBase>(faq: T): TFaqFormValues => ({
  [FaqFieldsNames.QUESTION]: faq?.question,
  [FaqFieldsNames.ANSWER]: faq?.answer,
});
